import React, { useEffect, useState } from 'react';
import styles from './AuthLayout.module.less';

const AUTO_ADVANCE_MS = 6000;

function prefersReducedMotion() {
  return (
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  );
}

const Arrow = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.4" aria-hidden="true">
    <path d="M5 12h13M12 5l7 7-7 7" />
  </svg>
);

// Presentational marketing carousel for the login left panel. Slides come from
// the server-seeded `carousel_slides` (see AuthLayout); no data fetching here.
const Carousel = ({ slides = [] }) => {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const count = slides.length;

  useEffect(() => {
    if (count <= 1 || paused || prefersReducedMotion()) return undefined;
    const timer = setInterval(() => setIndex((i) => (i + 1) % count), AUTO_ADVANCE_MS);
    return () => clearInterval(timer);
  }, [count, paused]);

  if (count === 0) return null;

  const slide = slides[Math.min(index, count - 1)];

  return (
    <div
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      onFocus={() => setPaused(true)}
      onBlur={() => setPaused(false)}
    >
      <div className={styles.card}>
        {slide.eyebrow && <span className={styles.eyebrow}>{slide.eyebrow}</span>}
        <h2 className={styles.slideTitle}>{slide.title}</h2>
        {slide.body && <p className={styles.slideBody}>{slide.body}</p>}
        {slide.ctaLabel && slide.ctaUrl && (
          <a className={styles.slideCta} href={slide.ctaUrl}>
            {slide.ctaLabel}
            <Arrow />
          </a>
        )}
      </div>
      {count > 1 && (
        <div className={styles.dots}>
          {slides.map((s, i) => (
            <button
              key={i}
              type="button"
              className={`${styles.dot} ${i === index ? styles.dotActive : ''}`}
              aria-label={`Go to slide ${i + 1}`}
              aria-current={i === index ? 'true' : undefined}
              onClick={() => setIndex(i)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default Carousel;
